import { Tag } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTicketData } from "../..";

type Props = {
  onClick: () => void;
  color: string;
};

export const SourceFilterLabel = observer((props: Props) => {
  const ticketData = useTicketData();

  return (
    <Tag
      style={{ cursor: "pointer", margin: 0 }}
      onClick={props.onClick}
      color={props.color}
    >
      {ticketData?.source?.name}
    </Tag>
  );
});
